import { render, staticRenderFns } from "./CompanyRequestAttachmentDialog.vue?vue&type=template&id=b44b8652"
import script from "./CompanyRequestAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./CompanyRequestAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports